import script from "./UploadAdapter.vue?vue&type=script&lang=js"
export * from "./UploadAdapter.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__